define(['core/services/api/ApiHttpService'], function(ApiHttpService) {
  function AccountService() {}

  AccountService.prototype.updateAccountTerms = function(termsUpdated) {
    return ApiHttpService.post('terms/UpdateTermsAccepted', termsUpdated);
  };

  return new AccountService();
});
